import { mapStrings } from "../../lib/frTypo";

/**
 * "La machine à sous" reel — on-screen copy, FR only for now.
 *
 * The brands, rewards and the brand count come from the live snapshot
 * (`npm run sync:brands`); the reward wording and footnote come from the
 * merchant video's copy (landing brands.* keys), the end line from the
 * B2C video (landing brands.hub.title). B2C house style: tutoiement, no
 * em dashes. A reward is always "jusqu'à", next to its mechanic and the
 * footnote.
 */
export const SLOTS = mapStrings({
  hook: "Tu recommandes quelle marque aujourd'hui ?",
  /** On the cover, before the first pull. */
  prompt: "Tire le levier",
  end: {
    line: "Des marques qui paient leurs ambassadeurs.",
    /** {n}: live brand count. */
    sub: "{n} marques à recommander. Gratuit, sans abonnés.",
  },
});
